'use client'

import { Error as ErrorComponent } from '@ui/nextjs'
import cn from '@config/tailwind/cn'

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang='id'>
      <body>
        <ErrorComponent locale='id' error={error} reset={reset} className={cn('h-dvh w-dvw')} />
      </body>
    </html>
  )
}
